import React from 'react'
import { Spinner } from 'react-bootstrap'

// eslint-disable-next-line react/no-unknown-property
const CustomLoader = () => (<div active='true'>
	<div className="commonLoader" data-testid='loaderCmp'>
		<div className="loaderWrap">
			<Spinner animation="border" />
		</div>
	</div>
</div>)

export default CustomLoader
